import React, { Component, Fragment } from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { DetailsList, DetailsRow, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { DataProgramme } from '../../data/DataProgramme.jsx';
import { FicheProgrammeNomenclatureOperis } from '../Fiche/FicheProgrammeNomenclatureOperis';
import { Immocom } from '../../specifique/immocom';
import './DetailsListProgrammeNomenclatureOperis.css'

var objetState = {
    items: [],
    idProgramme: 0,
    idNomenclature: 0,

    enCoursDeTraitement: false,
    onAfficheDialogSuppressionNomenclature: false,
    onAffichePanelNomenclatureOperis: false,

    hideMessageBarWarning: true,
    hideMessageBarError: true,
    hideMessageBarFiltres: true,
    warningMessage: '',
    errorMessage: '',
    messageMessageBarFiltres: '',
};


export class DetailsListProgrammeNomenclatureOperis extends Component {

    _creationContent() {
        const { items } = this.state;
        return (
            <>
                <div className="ms-Grid-col ms-sm12 bouton-padding">
                    <PrimaryButton text="Ajouter une nomenclature" onClick={() => this._onAffichePanelOperisNomenclature()} />
                </div>
                <div className="ms-Grid-col ms-sm12">
                    <DetailsList
                        items={items}
                        columns={this.columns}
                        selectionMode={SelectionMode.none}
                        onRenderRow={this._onRenderRow}
                    />
                </div>
            </>
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;

        let columnsTemp = [];

        columnsTemp.push({
            key: 'societe',
            name: 'Société',
            ariaLabel: 'Societe',
            fieldName: 'societe',
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let societe = item.societe;
                return <span title={societe}>{societe}</span>;
            }
        });
        columnsTemp.push({
            key: 'entite',
            name: 'Entité',
            ariaLabel: 'Entite',
            fieldName: 'entite',
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let entite = item.entite;
                return <span title={entite}>{entite}</span>;
            }
        });
        columnsTemp.push({
            key: 'activite',
            name: 'Activité',
            ariaLabel: 'Activite',
            fieldName: 'activite',
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let activite = item.activite;
                return <span title={activite}>{activite}</span>;
            }
        });
        columnsTemp.push({
            key: 'projet',
            name: 'Projet',
            ariaLabel: 'Projet',
            fieldName: 'projet',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let projet = item.projet;
                return <span title={projet}>{projet}</span>;
            }
        });

        columnsTemp.push({
            key: 'EditionSouhait',
            name: 'EditionSouhait',
            ariaLabel: 'Modifier le souhait',
            fieldName: 'EditionSouhait',
            minWidth: 20,
            maxWidth: 20,
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                return <IconButton
                    iconProps={{ iconName: 'Edit' }}
                    title="Modifier la nomenclature"
                    ariaLabel="Edition"
                    onClick={() => this._onAffichagePanelNomenclature(item.idNomenclature, item.idProgramme)}
                />;
            }
        });
        columnsTemp.push({
            key: 'delete',
            name: 'Delete',
            ariaLabel: 'Supprimer l\'historique',
            fieldName: 'delete',
            minWidth: 20,
            maxWidth: 20,
            iconName: '',
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                return <IconButton
                    iconProps={{ iconName: 'Delete' }}
                    title="Supprimer la nomenclature"
                    ariaLabel="Suppression"
                    onClick={() => this._onAffichageDialogSuppressionNomenclature(item.idNomenclature)}
                />;
            }
        });

        this.columns = columnsTemp;
    }

    _onAffichagePanelNomenclature = (idNomenclature, idProgramme) => {
        this.setState({
            idNomenclature,
            idProgramme,
            onAffichePanelNomenclatureOperis: true,
            warningMessage: ''
        });
    }

    _onAffichePanelOperisNomenclature = () => {
        this.setState({
            onAffichePanelNomenclatureOperis: true,
            warningMessage: ''
        });
    }

    _onAffichageDialogSuppressionNomenclature = (idNomenclature) => {
        this.setState({
            idNomenclature,
            onAfficheDialogSuppressionNomenclature: true,
        });
    }

    _chargementDonnees() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des nomenclature en cours'
        });

        let chargementOperisNomenclature = DataProgramme._chargementProgrameOperisNomenclature(this.props.idProgramme);

        chargementOperisNomenclature
            .then(responseFetch => {

                let retourData = responseFetch.reponseAPIobjet;

                this.setState({
                    items: retourData,
                    enCoursDeTraitement: false                    
                });
            });
    }

    _onRenderRow = (props) => {
        return <DetailsRow title="La prise en compte des liens avec Opéris sera effectif dans les bilans à J+1." {...props} />;
    }

    _onSuppressionNomenclature = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Suppression de la nomenclature en cours'
        });

        var onSuppressionHistorique = DataProgramme._onSuppressionOperisNomenclature(this.state.idNomenclature);

        onSuppressionHistorique
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    this.setState({
                        enCoursDeTraitement: false,
                        messageEnCoursTraitement: '',
                        hideMessageBarError: true,
                        errorMessage: '',                        

                        onAfficheDialogSuppressionNomenclature: false,

                        idNomenclature: 0
                    });

                    this._chargementDonnees();
                }
                else {
                    let stateTemp = {};
                    stateTemp.idNomenclature = 0;
                    stateTemp.onAfficheDialogSuppressionNomenclature = false;

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    _onCachePanelFicheNomenclatureOperis = () => {
        this.setState({
            idNomenclature: 0,
            onAffichePanelNomenclatureOperis: false,
            warningMessage: 'La prise en compte des liens avec Opéris sera effectif dans les bilans à J+1.'
        });

        this._chargementDonnees();
    }

    _onCacheDialogSuppressionNomenclature = () => {
        this.setState({
            onAfficheDialogSuppressionNomenclature: false
        });
    };

    _onAnnulePanelFicheNomenclatureOperis = () => {
        this.setState({
            idNomenclature: 0,
            onAffichePanelNomenclatureOperis: false
        });
    }

    componentDidMount() {
        this._chargementDonnees();
    }

    render = () => {
        const content = this._creationContent();

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}
            <Stack verticalFill>
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                {content}
            </Stack>
            <FicheProgrammeNomenclatureOperis
                onAffichePanelNomenclatureOperis={this.state.onAffichePanelNomenclatureOperis}
                idNomenclature={this.state.idNomenclature}
                onEnregistrementFiche={this._onCachePanelFicheNomenclatureOperis}
                idProgramme={this.props.idProgramme}
                idRegion={this.props.idRegion}
                idAgence={this.props.idAgence}
                onAnnuleFiche={this._onAnnulePanelFicheNomenclatureOperis}
            />
            <Dialog
                hidden={!this.state.onAfficheDialogSuppressionNomenclature}
                onDismiss={this._onCacheDialogSuppressionNomenclature}
                dialogContentProps={{
                    type: DialogType.largeHeader,
                    title: 'Suppression de la nomenclature',
                    subText: 'Vous êtes en train de supprimer cette nomenclature, voulez-vous continuer?'
                }}
                modalProps={{
                    isBlocking: false,
                    styles: { main: { maxWidth: 450 } }
                }}>
                <DialogFooter>
                    <PrimaryButton onClick={this._onSuppressionNomenclature} text="Supprimer" />
                    <DefaultButton onClick={this._onCacheDialogSuppressionNomenclature} text="Annuler" />
                </DialogFooter>
            </Dialog>
        </Fragment>;
    }
}